<template>
  <!--//@*/*
      //    *BUS Dice Cars  App v0.91
      //    * Copyright (c) 2022, Blue Cover Six LLC .John Molt All rights reserved.
      //    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
      //    */
      //-->

  <div>
    <div id="init-help-container" class="mt-3 d-flex" style="width: 100%">
      <v-spacer></v-spacer>
      <v-main>
        <div id="help-container" style="max-width: 768px">
          <h1>Pending</h1>
        </div>
      </v-main>
    </div>
  </div>
</template>
<style scoped></style>
<script>
import { bus_common } from "../mixins/bus_common";
export default {
  name: "rename",
  mixins: [bus_common],
  data: function () {
    return {
      item: "fish",
    };
  },
  watch: {},
  computed: {},
  methods: {
    init: function () {},
  },
  mounted() {
    this.$nextTick(() => {
      this.show_loader(false);
      // The whole view is rendered, so I can safely access or query
      // the DOM. ¯\_(ツ)_/¯
    });
  },
};
</script>

<style scoped>
@import url(https://themes.googleusercontent.com/fonts/css?kit=dpiI8CyVsrzWsJLBFKehGpLhv3qFjX7dUn1mYxfCXhI);

@media (min-width: 0) {
  .lst-kix_khbdk5w2opfi-6 > li:before {
    content: "\0025cf   ";
  }
  ul.lst-kix_buoardoew9h9-4 {
    list-style-type: none;
  }
  ul.lst-kix_buoardoew9h9-3 {
    list-style-type: none;
  }
  ul.lst-kix_buoardoew9h9-2 {
    list-style-type: none;
  }
  ul.lst-kix_buoardoew9h9-1 {
    list-style-type: none;
  }
  .lst-kix_khbdk5w2opfi-8 > li:before {
    content: "\0025a0   ";
  }
  ul.lst-kix_buoardoew9h9-8 {
    list-style-type: none;
  }
  ul.lst-kix_buoardoew9h9-7 {
    list-style-type: none;
  }
  .lst-kix_khbdk5w2opfi-5 > li:before {
    content: "\0025a0   ";
  }
  ul.lst-kix_buoardoew9h9-6 {
    list-style-type: none;
  }
  ul.lst-kix_buoardoew9h9-5 {
    list-style-type: none;
  }
  ul.lst-kix_mv35lkz6qym8-6 {
    list-style-type: none;
  }
  ul.lst-kix_mv35lkz6qym8-7 {
    list-style-type: none;
  }
  ul.lst-kix_mv35lkz6qym8-4 {
    list-style-type: none;
  }
  ul.lst-kix_mv35lkz6qym8-5 {
    list-style-type: none;
  }
  .lst-kix_khbdk5w2opfi-2 > li:before {
    content: "\0025a0   ";
  }
  .lst-kix_khbdk5w2opfi-4 > li:before {
    content: "\0025cb   ";
  }
  ul.lst-kix_mv35lkz6qym8-2 {
    list-style-type: none;
  }
  ul.lst-kix_mv35lkz6qym8-3 {
    list-style-type: none;
  }
  ul.lst-kix_mv35lkz6qym8-0 {
    list-style-type: none;
  }
  ul.lst-kix_mv35lkz6qym8-1 {
    list-style-type: none;
  }
  .lst-kix_khbdk5w2opfi-3 > li:before {
    content: "\0025cf   ";
  }
  .lst-kix_mv35lkz6qym8-4 > li:before {
    content: "\0025cb   ";
  }
  .lst-kix_khbdk5w2opfi-0 > li:before {
    content: "\0025cf   ";
  }
  .lst-kix_mv35lkz6qym8-3 > li:before {
    content: "\0025cf   ";
  }
  .lst-kix_khbdk5w2opfi-1 > li:before {
    content: "\0025cb   ";
  }
  .lst-kix_mv35lkz6qym8-0 > li:before {
    content: "\0025cf   ";
  }
  .lst-kix_mv35lkz6qym8-2 > li:before {
    content: "\0025a0   ";
  }
  .lst-kix_mv35lkz6qym8-1 > li:before {
    content: "\0025cb   ";
  }
  .lst-kix_buoardoew9h9-2 > li:before {
    content: "\0025a0   ";
  }
  .lst-kix_buoardoew9h9-4 > li:before {
    content: "\0025cb   ";
  }
  .lst-kix_buoardoew9h9-3 > li:before {
    content: "\0025cf   ";
  }
  .lst-kix_buoardoew9h9-6 > li:before {
    content: "\0025cf   ";
  }
  .lst-kix_mv35lkz6qym8-6 > li:before {
    content: "\0025cf   ";
  }
  .lst-kix_mv35lkz6qym8-5 > li:before {
    content: "\0025a0   ";
  }
  .lst-kix_buoardoew9h9-5 > li:before {
    content: "\0025a0   ";
  }
  .lst-kix_mv35lkz6qym8-7 > li:before {
    content: "\0025cb   ";
  }
  .lst-kix_mv35lkz6qym8-8 > li:before {
    content: "\0025a0   ";
  }
  .lst-kix_buoardoew9h9-0 > li:before {
    content: "\0025cf   ";
  }
  .lst-kix_buoardoew9h9-1 > li:before {
    content: "\0025cb   ";
  }
  .lst-kix_qdg6wq6bfu3c-0 > li:before {
    content: "\0025cf   ";
  }
  .lst-kix_qdg6wq6bfu3c-1 > li:before {
    content: "\0025cb   ";
  }
  .lst-kix_qdg6wq6bfu3c-2 > li:before {
    content: "\0025a0   ";
  }
  .lst-kix_qdg6wq6bfu3c-3 > li:before {
    content: "\0025cf   ";
  }
  ul.lst-kix_qdg6wq6bfu3c-8 {
    list-style-type: none;
  }
  ul.lst-kix_qdg6wq6bfu3c-6 {
    list-style-type: none;
  }
  ul.lst-kix_qdg6wq6bfu3c-7 {
    list-style-type: none;
  }
  ul.lst-kix_qdg6wq6bfu3c-4 {
    list-style-type: none;
  }
  ul.lst-kix_qdg6wq6bfu3c-5 {
    list-style-type: none;
  }
  ul.lst-kix_qdg6wq6bfu3c-2 {
    list-style-type: none;
  }
  ul.lst-kix_qdg6wq6bfu3c-3 {
    list-style-type: none;
  }
  .lst-kix_buoardoew9h9-7 > li:before {
    content: "\0025cb   ";
  }
  ul.lst-kix_qdg6wq6bfu3c-0 {
    list-style-type: none;
  }
  ul.lst-kix_qdg6wq6bfu3c-1 {
    list-style-type: none;
  }
  .lst-kix_buoardoew9h9-8 > li:before {
    content: "\0025a0   ";
  }
  ul.lst-kix_khbdk5w2opfi-3 {
    list-style-type: none;
  }
  ul.lst-kix_khbdk5w2opfi-4 {
    list-style-type: none;
  }
  ul.lst-kix_khbdk5w2opfi-1 {
    list-style-type: none;
  }
  ul.lst-kix_khbdk5w2opfi-2 {
    list-style-type: none;
  }
  ul.lst-kix_khbdk5w2opfi-7 {
    list-style-type: none;
  }
  ul.lst-kix_khbdk5w2opfi-8 {
    list-style-type: none;
  }
  ul.lst-kix_khbdk5w2opfi-5 {
    list-style-type: none;
  }
  ul.lst-kix_khbdk5w2opfi-6 {
    list-style-type: none;
  }
  ul.lst-kix_khbdk5w2opfi-0 {
    list-style-type: none;
  }
  li.li-bullet-0:before {
    margin-left: -18pt;
    white-space: nowrap;
    display: inline-block;
    min-width: 18pt;
  }
  .lst-kix_qdg6wq6bfu3c-8 > li:before {
    content: "\0025a0   ";
  }
  .lst-kix_qdg6wq6bfu3c-6 > li:before {
    content: "\0025cf   ";
  }
  .lst-kix_qdg6wq6bfu3c-7 > li:before {
    content: "\0025cb   ";
  }
  ul.lst-kix_mv35lkz6qym8-8 {
    list-style-type: none;
  }
  .lst-kix_qdg6wq6bfu3c-4 > li:before {
    content: "\0025cb   ";
  }
  .lst-kix_qdg6wq6bfu3c-5 > li:before {
    content: "\0025a0   ";
  }
  ul.lst-kix_buoardoew9h9-0 {
    list-style-type: none;
  }
  .lst-kix_khbdk5w2opfi-7 > li:before {
    content: "\0025cb   ";
  }
  ol {
    margin: 0;
    padding: 0;
  }
  table td,
  table th {
    padding: 0;
  }
  .c2 {
    margin-left: 36pt;
    padding-top: 0pt;
    padding-left: 0pt;
    padding-bottom: 0pt;
    line-height: 1.15;
    orphans: 2;
    widows: 2;
    text-align: left;
  }
  .c1 {
    margin-left: 36pt;
    padding-top: 0pt;
    padding-bottom: 0pt;
    line-height: 1.15;
    orphans: 2;
    widows: 2;
    text-align: left;
    height: 11pt;
  }
  .c0 {
    color: #000000;
    font-weight: 400;
    text-decoration: none;
    vertical-align: baseline;
    font-size: 12pt;
    font-family: "Roboto";
    font-style: normal;
  }
  .c3 {
    color: #000000;
    font-weight: 700;
    text-decoration: none;
    vertical-align: baseline;
    font-size: 12pt;
    font-family: "Roboto";
    font-style: normal;
  }
  .c5 {
    padding-top: 0pt;
    padding-bottom: 0pt;
    line-height: 1.15;
    orphans: 2;
    widows: 2;
    text-align: left;
  }
  .c7 {
    font-size: 12pt;
    font-family: "Roboto";
    font-weight: 700;
  }
  .c8 {
    background-color: #ffffff;
    max-width: 768px;
    padding: 10px;
    margin-top: 18px;
  }
  .c4 {
    padding: 0;
    margin: 0;
  }
  .c6 {
    height: 11pt;
  }
  .title {
    padding-top: 0pt;
    color: #000000;
    font-size: 26pt;
    padding-bottom: 3pt;
    font-family: "Arial";
    line-height: 1.15;
    page-break-after: avoid;
    orphans: 2;
    widows: 2;
    text-align: left;
  }
  .subtitle {
    padding-top: 0pt;
    color: #666666;
    font-size: 15pt;
    padding-bottom: 16pt;
    font-family: "Arial";
    line-height: 1.15;
    page-break-after: avoid;
    orphans: 2;
    widows: 2;
    text-align: left;
  }
  li {
    color: #000000;
    font-size: 11pt;
    font-family: "Arial";
  }
  p {
    margin: 0;
    color: #000000;
    font-size: 11pt;
    font-family: "Arial";
  }
  h1 {
    padding-top: 20pt;
    color: #000000;
    font-size: 20pt;
    padding-bottom: 6pt;
    font-family: "Arial";
    line-height: 1.15;
    page-break-after: avoid;
    orphans: 2;
    widows: 2;
    text-align: left;
  }
  h2 {
    padding-top: 18pt;
    color: #000000;
    font-size: 16pt;
    padding-bottom: 6pt;
    font-family: "Arial";
    line-height: 1.15;
    page-break-after: avoid;
    orphans: 2;
    widows: 2;
    text-align: left;
  }
  h3 {
    padding-top: 16pt;
    color: #434343;
    font-size: 14pt;
    padding-bottom: 4pt;
    font-family: "Arial";
    line-height: 1.15;
    page-break-after: avoid;
    orphans: 2;
    widows: 2;
    text-align: left;
  }
  h4 {
    padding-top: 14pt;
    color: #666666;
    font-size: 12pt;
    padding-bottom: 4pt;
    font-family: "Arial";
    line-height: 1.15;
    page-break-after: avoid;
    orphans: 2;
    widows: 2;
    text-align: left;
  }
  h5 {
    padding-top: 12pt;
    color: #666666;
    font-size: 11pt;
    padding-bottom: 4pt;
    font-family: "Arial";
    line-height: 1.15;
    page-break-after: avoid;
    orphans: 2;
    widows: 2;
    text-align: left;
  }
  h6 {
    padding-top: 12pt;
    color: #666666;
    font-size: 11pt;
    padding-bottom: 4pt;
    font-family: "Arial";
    line-height: 1.15;
    page-break-after: avoid;
    font-style: italic;
    orphans: 2;
    widows: 2;
    text-align: left;
  }
}

@media (min-width: 768px) {
  .c8 {
    background-color: #ffffff;
    max-width: 768px;
    padding: 72pt 72pt 72pt 72pt;
    margin-top: 18px;
  }
}
</style>
